import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const CitizenService = {
    list: async (filter) => axios.post(API_KEEPER + "/sos/citizen/list", filter).then(({data}) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + "/sos/citizen/" + id).then(({data}) => data).catch((err) => { throw err }),

    options: async () => axios.get(API_KEEPER + "/sos/citizen/options").then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_KEEPER + "/sos/citizen/register", data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (data) => axios.post(API_KEEPER + "/sos/citizen/update", data).then(({data}) => data).catch((err) => { throw err }),

    getEducations: async () => axios.get(API_KEEPER + "/sos/citizen/info/educations").then(({data}) => data.data).catch((err) => { throw err }),

    getRaces: async () => axios.get(API_KEEPER + "/sos/citizen/info/races").then(({data}) => data.data).catch((err) => { throw err }),

    getReligions: async () => axios.get(API_KEEPER + "/sos/citizen/info/religions").then(({data}) => data.data).catch((err) => { throw err }),

    getFamilyConnections: async () => axios.get(API_KEEPER + "/sos/citizen/info/familyConnections").then(({data}) => data.data).catch((err) => { throw err }),

    getCitizensByAggressor: async (cpf, id = "-1") => axios.get(API_KEEPER + `/sos/citizen/by-aggressors/${cpf}/${id}`).then(({data}) => data).catch((err) => { throw err }),

    createOccurrence: async (plate) => axios.post(API_URL + "/citizens/createOccurrence", {plate}).catch((err) => { throw err }),

    importPreview: async (data) => axios.post(API_KEEPER + "/sos/citizen/import/preview", data).catch((err) => { throw err }),

    import: async (data) => axios.post(API_KEEPER + "/sos/citizen/import", data).catch((err) => { throw err }),

    changePassword: async (citizenId) => axios.get(API_KEEPER + "/sos/citizen/agent/changePassword/" + citizenId).then(({data}) => data).catch((err) => { throw err }),

    removeCredential: async (id) => axios.delete(API_KEEPER + "/sos/credentials/delete/" + id).catch((err) => { throw err }),

    programUsers: async (protectionProgramIds) => axios.post(API_KEEPER + "/sos/protection-program/users", {protectionProgramIds}).then(({data}) => data),
};

export default CitizenService;